(function requestIdleCallback(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  if (!global.NewHomeSource.Modules.IdleDeadline) {
    return;
  }

  const previousRequestIdleCallback = global.NewHomeSource.Modules.requestIdleCallback;
  const isRequestIdleCallbackSupported = typeof global.requestIdleCallback === 'function';

  /**
   * @private
   * cancelIdleCallbackShim: polyfills the cancelIdleCallback.
   *
   * @param {number} of the ID of the timeout function to cancel.
   */
  function cancelIdleCallbackShim(handle) {
    clearTimeout(handle);
  }

  /**
   * @private
   * requestIdleCallbackShim: polyfills the requestIdleCallback.
   *
   * @param {function} callback that will run in the next idle period.
   */
  function requestIdleCallbackShim(callback) {
    const deadline = new global.NewHomeSource.Modules.IdleDeadline();
    return setTimeout(() => {
      callback(deadline);
    }, 0);
  }

  /**
   * @constructs NewHomeSource.Modules.requestIdleCallback
   */
  function RequestIdleCallback() {
  }

  /**
   * @public
   * cIC: returns a cancelIdleCallback function.
   *
   * @param {any} handle that references the requestIdleCallback.
   */
  RequestIdleCallback.cIC = function cIC(handle) {
    return isRequestIdleCallbackSupported ? global.cancelIdleCallback(handle) : cancelIdleCallbackShim(handle);
  };

  /**
   * @public
   * rIC: returns a requestIdleCallback function.
   *
   * @param {function} callback to execute in an idle period.
   * @param {number} timeout max time to wait before running the callback.
   */
  RequestIdleCallback.rIC = function rIC(callback, timeout) {
    return isRequestIdleCallbackSupported
      ? global.requestIdleCallback(callback, timeout)
      : requestIdleCallbackShim(callback);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  RequestIdleCallback.noConflict = function noConflict() {
    global.NewHomeSource.Modules.requestIdleCallback = previousRequestIdleCallback;
    return RequestIdleCallback;
  };

  global.NewHomeSource.Modules.requestIdleCallback = RequestIdleCallback;
}(window));
